export const routes = [
    {
        href: "/",
        name: "Overzicht"
    }
]